<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  cost: number
}>()

const creditsUsed = computed(() => Math.trunc(props.cost || 0))
</script>

<template>
  <span class="text-[11px] font-medium text-neutral-500 whitespace-nowrap">
    credits consumed: <span class="font-semibold text-neutral-700">{{ creditsUsed }}</span>
  </span>
</template>
